export const categories = [
  {
    slug: 'school-romance',
    name: '校园恋爱',
    description: '甜蜜校园恋情，青春悸动的浪漫故事',
    subCategories: ['纯爱', '反转', '甜宠', '治愈'],
  },
  {
    slug: 'fantasy',
    name: '奇幻冒险',
    description: '穿越异世界，开启史诗级冒险之旅',
    subCategories: ['穿越', '魔法', '异世界', '转生'],
  },
  {
    slug: 'action',
    name: '热血动作',
    description: '燃爆荷尔蒙，酣畅淋漓的战斗场面',
    subCategories: ['格斗', '竞技', '复仇', '成长'],
  },
  {
    slug: 'thriller',
    name: '悬疑惊悚',
    description: '扣人心弦的悬疑推理，步步惊心',
    subCategories: ['推理', '恐怖', '犯罪', '心理'],
  },
];

export const featuredComics = [
  {
    id: 'goddess-bodyguard',
    title: '女神的贴身高手',
    author: '八神',
    category: 'school-romance',
    categoryName: '校园恋爱',
    rating: 9.8,
    views: '2.3M',
    status: '连载中',
    isFree: true,
    latestChapter: '第238话',
    description: '平凡大学生意外成为校花女神的贴身保镖，从此开启了一段充满笑料与心跳的校园生活。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20dramatic%20scene%20with%20handsome%20bodyguard%20and%20beautiful%20goddess%20character%2C%20warm%20coral%20and%20rose%20pink%20accents%2C%20clean%20composition%20with%20simple%20dark%20background%2C%20professional%20webtoon%20quality&width=800&height=600&seq=comic-goddess-bodyguard-feat&orientation=landscape',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thumbnail%20style%2C%20handsome%20male%20lead%20character%20portrait%2C%20warm%20coral%20tones%2C%20clean%20dark%20background%2C%20webtoon%20cover%20thumbnail%20quality&width=300&height=400&seq=comic-goddess-bodyguard-thumb&orientation=portrait',
  },
  {
    id: 'urban-cultivation',
    title: '重生之都市修仙',
    author: '十里剑神',
    category: 'fantasy',
    categoryName: '奇幻冒险',
    rating: 9.6,
    views: '1.8M',
    status: '连载中',
    isFree: true,
    latestChapter: '第156话',
    description: '仙界大能渡劫失败重回都市少年时代，这一世他要弥补所有遗憾。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20character%20illustration%2C%20powerful%20cultivator%20in%20urban%20setting%2C%20dramatic%20lighting%20with%20warm%20coral%20and%20rose%20pink%20highlights%2C%20clean%20simple%20dark%20background%2C%20professional%20webtoon%20cover%20quality&width=600&height=800&seq=comic-urban-cultivation-side&orientation=portrait',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thumbnail%20style%2C%20cultivation%20character%20portrait%2C%20warm%20coral%20tones%2C%20clean%20dark%20background%2C%20webtoon%20cover%20thumbnail%20quality&width=300&height=400&seq=comic-urban-cultivation-thumb&orientation=portrait',
  },
  {
    id: 'solo-leveling',
    title: '我独自升级',
    author: 'Chugong',
    category: 'action',
    categoryName: '热血动作',
    rating: 9.9,
    views: '5.1M',
    status: '已完结',
    isFree: false,
    latestChapter: '第179话（完结）',
    description: '最弱猎人程肖宇在死亡边缘获得神秘系统，从此开始独自升级之路。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20character%20illustration%2C%20powerful%20hunter%20with%20dark%20aura%2C%20dramatic%20lighting%20with%20warm%20coral%20and%20rose%20pink%20highlights%2C%20clean%20simple%20dark%20background%2C%20professional%20webtoon%20cover%20quality&width=600&height=800&seq=comic-solo-leveling-side&orientation=portrait',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thumbnail%20style%2C%20solo%20leveling%20character%20portrait%2C%20warm%20coral%20tones%2C%20clean%20dark%20background%2C%20webtoon%20cover%20thumbnail%20quality&width=300&height=400&seq=comic-solo-leveling-thumb&orientation=portrait',
  },
  {
    id: 'duke-fiancee',
    title: '公爵的契约未婚妻',
    author: 'Milcha',
    category: 'school-romance',
    categoryName: '校园恋爱',
    rating: 9.5,
    views: '1.2M',
    status: '连载中',
    isFree: true,
    latestChapter: '第89话',
    description: '现代女孩意外穿越成为小说中的配角，为了生存与冷酷公爵订下婚约。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thumbnail%20style%2C%20elegant%20duke%20and%20heroine%20romance%20illustration%2C%20warm%20coral%20and%20rose%20pink%20color%20scheme%2C%20clean%20dark%20background%2C%20webtoon%20cover%20thumbnail%20quality&width=300&height=400&seq=comic-duke-fiancee-small&orientation=portrait',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thumbnail%20style%2C%20royal%20romance%20character%20portrait%2C%20warm%20coral%20tones%2C%20clean%20dark%20background%2C%20webtoon%20cover%20thumbnail%20quality&width=300&height=400&seq=comic-duke-fiancee-thumb&orientation=portrait',
  },
  {
    id: 'dungeon-reset',
    title: '地下城重置',
    author: 'Daul',
    category: 'fantasy',
    categoryName: '奇幻冒险',
    rating: 9.3,
    views: '980K',
    status: '连载中',
    isFree: true,
    latestChapter: '第112话',
    description: '被困在无限地下城中的玩家发现自己是唯一拥有重置能力的人。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thumbnail%20style%2C%20dungeon%20adventure%20character%20portrait%2C%20warm%20coral%20and%20rose%20pink%20color%20scheme%2C%20clean%20dark%20background%2C%20webtoon%20cover%20thumbnail%20quality&width=300&height=400&seq=comic-dungeon-reset-small&orientation=portrait',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thumbnail%20style%2C%20dungeon%20explorer%20character%20portrait%2C%20warm%20coral%20tones%2C%20clean%20dark%20background%2C%20webtoon%20cover%20thumbnail%20quality&width=300&height=400&seq=comic-dungeon-reset-thumb&orientation=portrait',
  },
  {
    id: 'demon-lord',
    title: '魔王学院的不适格者',
    author: '秋',
    category: 'fantasy',
    categoryName: '奇幻冒险',
    rating: 9.4,
    views: '1.5M',
    status: '已完结',
    isFree: false,
    latestChapter: '第200话（完结）',
    description: '转生两千年后的魔王发现自己的后代已经遗忘了他的威名。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thumbnail%20style%2C%20demon%20lord%20character%20portrait%2C%20warm%20coral%20and%20rose%20pink%20color%20scheme%2C%20clean%20dark%20background%2C%20webtoon%20cover%20thumbnail%20quality&width=300&height=400&seq=comic-demon-lord-small&orientation=portrait',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thumbnail%20style%2C%20demon%20lord%20academy%20character%20portrait%2C%20warm%20coral%20tones%2C%20clean%20dark%20background%2C%20webtoon%20cover%20thumbnail%20quality&width=300&height=400&seq=comic-demon-lord-thumb&orientation=portrait',
  },
  {
    id: 'secret-class',
    title: '秘密教学',
    author: 'Youn',
    category: 'school-romance',
    categoryName: '校园恋爱',
    rating: 9.2,
    views: '890K',
    status: '连载中',
    isFree: true,
    latestChapter: '第67话',
    description: '学霸女主与学渣男主之间的秘密辅导，让两人的关系悄然发生变化。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thumbnail%20style%2C%20school%20romance%20character%20portrait%2C%20warm%20coral%20and%20rose%20pink%20color%20scheme%2C%20clean%20dark%20background%2C%20webtoon%20cover%20thumbnail%20quality&width=300&height=400&seq=comic-secret-class-small&orientation=portrait',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thumbnail%20style%2C%20secret%20tutoring%20character%20portrait%2C%20warm%20coral%20tones%2C%20clean%20dark%20background%2C%20webtoon%20cover%20thumbnail%20quality&width=300&height=400&seq=comic-secret-class-thumb&orientation=portrait',
  },
  {
    id: 'blade-evolution',
    title: '刃之进化',
    author: 'Redice',
    category: 'action',
    categoryName: '热血动作',
    rating: 9.7,
    views: '2.0M',
    status: '连载中',
    isFree: true,
    latestChapter: '第145话',
    description: '少年获得神秘之刃，在怪物横行的世界中不断进化变强。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thumbnail%20style%2C%20blade%20wielder%20character%20portrait%2C%20warm%20coral%20and%20rose%20pink%20color%20scheme%2C%20clean%20dark%20background%2C%20webtoon%20cover%20thumbnail%20quality&width=300&height=400&seq=comic-blade-evolution-small&orientation=portrait',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thumbnail%20style%2C%20blade%20evolution%20character%20portrait%2C%20warm%20coral%20tones%2C%20clean%20dark%20background%2C%20webtoon%20cover%20thumbnail%20quality&width=300&height=400&seq=comic-blade-evolution-thumb&orientation=portrait',
  },
];

export const latestUpdates = [
  {
    id: 'new-1',
    title: '大小姐的贴身管家',
    latestChapter: '第342话',
    updateTime: '2小时前',
    isFree: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%2C%20elegant%20butler%20and%20noble%20lady%20scene%2C%20warm%20coral%20tones%20with%20rose%20pink%20accents%2C%20simple%20dark%20background%2C%20professional%20webtoon%20quality%2C%20vertical%20portrait%20format&width=450&height=600&seq=comic-lady-butler-latest&orientation=portrait',
  },
  {
    id: 'new-2',
    title: '最强赘婿',
    latestChapter: '第521话',
    updateTime: '3小时前',
    isFree: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%2C%20powerful%20son%20in%20law%20character%20scene%2C%20warm%20coral%20tones%20with%20rose%20pink%20accents%2C%20simple%20dark%20background%2C%20professional%20webtoon%20quality&width=450&height=600&seq=comic-strongest-son-in-law-latest&orientation=portrait',
  },
  {
    id: 'new-3',
    title: '剑道独尊',
    latestChapter: '第198话',
    updateTime: '5小时前',
    isFree: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%2C%20sword%20master%20dramatic%20scene%2C%20warm%20coral%20tones%20with%20rose%20pink%20accents%2C%20simple%20dark%20background%2C%20professional%20webtoon%20quality&width=450&height=600&seq=comic-sword-dominance-latest&orientation=portrait',
  },
  {
    id: 'new-4',
    title: '恶魔契约',
    latestChapter: '第76话',
    updateTime: '6小时前',
    isFree: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%2C%20demon%20contract%20fantasy%20scene%2C%20warm%20coral%20tones%20with%20rose%20pink%20accents%2C%20simple%20dark%20background%2C%20professional%20webtoon%20quality&width=450&height=600&seq=comic-demon-contract-latest&orientation=portrait',
  },
  {
    id: 'new-5',
    title: '我的女友是九尾狐',
    latestChapter: '第203话',
    updateTime: '8小时前',
    isFree: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%2C%20nine%20tailed%20fox%20romance%20scene%2C%20warm%20coral%20tones%20with%20rose%20pink%20accents%2C%20simple%20dark%20background%2C%20professional%20webtoon%20quality&width=450&height=600&seq=comic-nine-tail-fox-latest&orientation=portrait',
  },
  {
    id: 'new-6',
    title: '暗黑破坏神之怒',
    latestChapter: '第89话',
    updateTime: '10小时前',
    isFree: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%2C%20dark%20fantasy%20wrath%20scene%2C%20warm%20coral%20tones%20with%20rose%20pink%20accents%2C%20simple%20dark%20background%2C%20professional%20webtoon%20quality&width=450&height=600&seq=comic-diablo-wrath-latest&orientation=portrait',
  },
  {
    id: 'new-7',
    title: '全职猎人之重生',
    latestChapter: '第167话',
    updateTime: '12小时前',
    isFree: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%2C%20hunter%20rebirth%20action%20scene%2C%20warm%20coral%20tones%20with%20rose%20pink%20accents%2C%20simple%20dark%20background%2C%20professional%20webtoon%20quality&width=450&height=600&seq=comic-hunter-rebirth-latest&orientation=portrait',
  },
  {
    id: 'new-8',
    title: '斗罗之绝世唐门',
    latestChapter: '第412话',
    updateTime: '14小时前',
    isFree: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%2C%20soul%20land%20epic%20scene%2C%20warm%20coral%20tones%20with%20rose%20pink%20accents%2C%20simple%20dark%20background%2C%20professional%20webtoon%20quality&width=450&height=600&seq=comic-douluo-door-latest&orientation=portrait',
  },
];

export const testimonials = [
  {
    id: 'test-1',
    name: '漫画控小明',
    level: 'VIP会员',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20male%20character%20portrait%20avatar%2C%20stylish%20casual%20look%2C%20soft%20warm%20lighting%2C%20neutral%20gray%20background%2C%20clean%20illustration%20style%2C%20square%20format&width=300&height=300&seq=avatar-user-1&orientation=squarish',
    content: '从大学开始就在韩漫网看漫画了，五年老用户！更新速度真的快，画质也是一流。最爱的《我独自升级》就是在这里追完的，强烈推荐给所有韩漫爱好者！界面干净整洁，完全没有烦人的弹窗广告，阅读体验超棒。',
  },
  {
    id: 'test-2',
    name: '二次元少女',
    level: '黄金会员',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20female%20character%20portrait%20avatar%2C%20cute%20casual%20look%2C%20soft%20warm%20lighting%2C%20neutral%20gray%20background%2C%20clean%20illustration%20style%2C%20square%20format&width=300&height=300&seq=avatar-user-2&orientation=squarish',
    content: '韩漫网的分类特别细致，找漫画超方便！校园恋爱类是我的最爱，每天都要上来看看有没有更新。而且免费作品真的很多，不用花钱就能看到大量优质内容。朋友推荐来的，现在我也成了忠实用户！',
  },
  {
    id: 'test-3',
    name: '资深漫迷老张',
    level: '钻石会员',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Anime%20style%20mature%20male%20character%20portrait%20avatar%2C%20experienced%20look%2C%20soft%20warm%20lighting%2C%20neutral%20gray%20background%2C%20clean%20illustration%20style%2C%20square%20format&width=300&height=300&seq=avatar-user-3&orientation=squarish',
    content: '作为一个看了二十年漫画的老漫迷，韩漫网是我见过最专业的韩漫平台。收录作品非常全，很多冷门佳作都能找到。高清画质对手机阅读特别友好，加载速度也很快，强烈安利！',
  },
];

export const advantages = [
  {
    icon: 'ri-book-read-line',
    title: '海量免费',
    description: '收录超过5000部韩漫作品，大量免费内容随时畅读，无需付费即可享受优质漫画体验。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    description: '全部采用原版高清图源，每一页都色彩饱满、细节丰富，为读者呈现极致视觉享受。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    description: '编辑团队全天候追踪最新连载，确保读者第一时间看到最新章节，追更快人一步。',
  },
  {
    icon: 'ri-device-line',
    title: '多端适配',
    description: '完美适配电脑、平板和手机等多终端设备，随时随地畅享流畅的漫画阅读体验。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '无广告干扰',
    description: '纯净阅读环境，无弹窗、无插屏广告干扰，让您沉浸式享受每一页漫画的精彩。',
  },
  {
    icon: 'ri-user-smile-line',
    title: '无需注册',
    description: '打开即看，无需复杂注册流程。保护您的隐私，让阅读回归纯粹的快乐。',
  },
];